import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { UsersService } from '../../services/users/users.service';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormBuilder,FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsersComponent implements OnInit {
  users: any = [];
  text:any="";
  formGroup:FormGroup;
  itemName: any = [];
  itemDetails: any = [];
  constructor(private as: UsersService,private modalService: NgbModal,private fb:FormBuilder) {
    this.as.getUsers(1,this.text).subscribe((res) => {
      if (res.status == true) {
        this.users = res.data;
      }
    })
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }
  ngOnInit() {}
  assumptionsEdit(item,content){
    this.formGroup=this.fb.group({data:item[1]})
  
    this. open(content);
    this.itemDetails=item
  }
  onPageChange(page){
    this.as.getUsers(page,this.text).subscribe((res) => {
      if (res.status == true) {
        this.users = res.data;
      }
    })
  }
  search(text){
    this.text=text.value;
    this.as.getUsers(1,this.text).subscribe((res) => {
      if (res.status == true) {
        this.users = res.data;
      }
    })
  }
  onUpdate(content){
    // this.users[this.itemDetails[0]]=Number(this.formGroup.value.data); 
    // this.as.putAssumption(this.assumptions,this.assumptions._id).subscribe((res) => {
    //   if (res.success == true) {
    //     this.keys=Object.keys(res.data);
    //     this.keys=this.keys.filter((item)=>{
    //         return item!="__v" && item!="_id";
    //     })
    //     this.keys.forEach(item => {
    //       this.itemName.push(item.replace(/_/g," "))
    //     });
    //     this.assumptions = res.data;
    //   }
    // });
  }
}
